var React = require('react');

function ColorFull (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"11","cy":"11","r":"10","fill":"#fff","stroke":"#FC8309","strokeWidth":"1","key":0}),React.createElement("circle",{"cx":"6.2","cy":"15.8","r":"1.6","fill":"#FC8309","key":1}),React.createElement("path",{"fill":"#FC8309","d":"M4.6 4.6h12.8v12.8L4.6 4.6Z","key":2}),React.createElement("path",{"fill":"red","d":"M4.6 9.4h8v8l-8-8Z","key":3})]);
}

ColorFull.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = ColorFull;

ColorFull.default = ColorFull;
